/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li3Inputs */

const tr_mesafeli_s20_li3 = /** @type {(inputs: Mesafeli_S20_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yabancılık unsuru taşıyan uyuşmazlıklar MÖHUK çerçevesinde değerlendirilir.`)
};

const en_mesafeli_s20_li3 = /** @type {(inputs: Mesafeli_S20_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disputes containing a foreign element are assessed within the framework of the MÖHUK.`)
};

const de_mesafeli_s20_li3 = /** @type {(inputs: Mesafeli_S20_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streitigkeiten mit Auslandsbezug werden im Rahmen des MÖHUK beurteilt.`)
};

const ru_mesafeli_s20_li3 = /** @type {(inputs: Mesafeli_S20_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Споры с иностранным элементом рассматриваются в рамках MÖHUK.`)
};

/**
* | output |
* | --- |
* | "Disputes containing a foreign element are assessed within the framework of the MÖHUK." |
*
* @param {Mesafeli_S20_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li3 = /** @type {((inputs?: Mesafeli_S20_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li3(inputs)
	if (locale === "de") return de_mesafeli_s20_li3(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li3(inputs)
	return tr_mesafeli_s20_li3(inputs)
});